import { TimeZone } from '../../../domain/models/timezone';
import { isObject } from '../types/isObject';
import { currentTimeZone } from './currentTimeZone';


function format(value: number, length: number) {
    return value.toString(10).padStart(length, '0');
}

function ymd(date: Date): string {
    return format(date.getUTCFullYear(), 4) + '-' +
        format(date.getUTCMonth() + 1, 2) + '-' +
        format(date.getUTCDate(), 2);
}

function hm(date: Date) {
    return format(date.getUTCHours(), 2) + ':' +
        format(date.getUTCMinutes(), 2);
}

function hms(date: Date) {
    return format(date.getUTCHours(), 2) + ':' +
        format(date.getUTCMinutes(), 2) + ':' +
        format(date.getUTCSeconds(), 2);
}

const dayNames: { [index: number]: string } = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
};

function dayOfWeek(date: Date): string {
    return dayNames[date.getUTCDay()];
}


/******************************************************************************/
export function offsetTime(time: number,
    offset: TimeZone | number | boolean): Date {
    if (isObject(offset))
        offset = offset.UtcOffsetMinutes;
    if (offset === true)
        offset = currentTimeZone().UtcOffsetMinutes;
    if (offset === false)
        offset = 0;
    time += offset * 60;
    return new Date(time * 1000);
}

/******************************************************************************/

const dateFormats = [
    'ymd',
    'hm',
    'hms',
    'ymdhm',
    'ymdhms',
    'wymdhms',
    'wymdhm'
] as const;

export type DateFormatEnum = typeof dateFormats[number];

export function dateFormat(time: null,
    format: DateFormatEnum,
    offset: TimeZone | number | boolean): null;

export function dateFormat(time: number,
    format: DateFormatEnum,
    offset: TimeZone | number | boolean): string;

export function dateFormat(time: number | null,
    format: DateFormatEnum,
    offset: TimeZone | number | boolean): string | null;

export function dateFormat(time: number | null,
    format: DateFormatEnum,
    offset: TimeZone | number | boolean): string | null {
    if (time === null)
        return null;
    const date = offsetTime(time, offset);
    switch (format) {
        case 'ymd':
            return ymd(date);
        case 'hm':
            return hm(date);
        case 'hms':
            return hms(date);
        case 'ymdhm':
            return ymd(date) + ' ' + hm(date);
        case 'ymdhms':
            return ymd(date) + ' ' + hms(date);
        case 'wymdhm':
            return dayOfWeek(date) + ' ' + ymd(date) + ' ' + hm(date);
        case 'wymdhms':
            return dayOfWeek(date) + ' ' + ymd(date) + ' ' + hms(date);
        default:
            return dayOfWeek(date) + ' ' + ymd(date) + ' ' + hms(date);
    }
}

export function msToHumanTime(duration: number): string {
    var minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    let parts: string[] = [];
    if (hours > 0) {
        parts.push(`${hours}h`);
    }
    if (minutes > 0) {
        parts.push(`${minutes}m`);
    }
    return parts.join(' ');
}
